import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';

const AccessibilityPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Accessibility Notice | Stitch Fix"
        description="Stitch Fix is committed to making our website accessible to all users. Learn more about our accessibility efforts."
        canonicalUrl="https://www.stitchfix.com/accessibility"
      />
      <ResponsiveSection
        as="main"
        // setting this id allows the "Skip to page content" link to render from knit
        id="knit-main-content"
        mt="0"
        width={{ sm: 'full-bleed' }}
        gutter="none"
      >
        <OneTrustContent documentID="cf254b76-64ae-44ce-a098-dabb6d9102de" />
      </ResponsiveSection>
    </Layout>
  );
};

export default AccessibilityPage;
